import React from 'react';
import moment from 'moment';
import styles from './MetersHistory.module.scss';
import LongArrowRight from '../../../../resource/LongArrowRight.svg';
import { Empty } from 'antd';

const MetersHistory = ({ meterReading }) => {
  return (
    <div className={styles.outer}>
      <div className={styles.metersHistoryContent}>
        <div className={styles.name}>История показаний</div>
        {meterReading?.map((entry, index) => {
          const tariffName = entry.tariff.name.includes(' ')
            ? entry.tariff.name.split(' ')[1]
            : entry.tariff.name;

          const partOfDay =
            tariffName === 'День' || tariffName === 'Ночь'
              ? tariffName
              : 'Общее';

          return (
            <div className={styles.row} key={index}>
              <div className={styles.date}>
                {moment(entry.date).format('DD.MM.YYYY, HH:mm')}
              </div>
              <div className={styles.fullName}>
                {entry.worker.fullName.trim()}
              </div>
              <div className={styles.reading}>
                <span className={styles.partOfDay}>{partOfDay}</span>
                <span className={styles.meters}>
                  <span className={styles.dBlock}>{entry.previousValue}</span>
                  <img className={styles.arrow} src={LongArrowRight} alt={''} />
                  <span className={styles.dBlock}>{entry.value}</span>
                </span>
              </div>
            </div>
          );
        })}
        {!meterReading.length && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      </div>
    </div>
  );
};

export default MetersHistory;
